var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApkFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6401_56898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6401_56898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 22C2.45 22 1.97917 21.8042 1.5875 21.4125C1.19583 21.0208 1 20.55 1 20V4C1 3.45 1.19583 2.97917 1.5875 2.5875C1.97917 2.19583 2.45 2 3 2H11L17 8V12.25H15V9H10V4H3V20H14V22H3ZM4 19C4.06667 18.1833 4.31667 17.4333 4.75 16.75C5.18333 16.0667 5.75 15.525 6.45 15.125L5.5 13.425C5.5 13.4083 5.53333 13.2833 5.6 13.05C5.68333 13.0167 5.7625 13 5.8375 13C5.9125 13 5.96667 13.0417 6 13.125L6.975 14.875C7.30833 14.7417 7.64167 14.6375 7.975 14.5625C8.30833 14.4875 8.65 14.45 9 14.45C9.35 14.45 9.69167 14.4875 10.025 14.5625C10.3583 14.6375 10.6917 14.7417 11.025 14.875L12 13.125L12.375 13.025C12.4583 13.0583 12.5083 13.1167 12.525 13.2C12.5417 13.2833 12.5333 13.3583 12.5 13.425L11.55 15.125C12.25 15.525 12.8167 16.0667 13.25 16.75C13.6833 17.4333 13.9333 18.1833 14 19H4ZM6.75 17.5C6.88333 17.5 7 17.45 7.1 17.35C7.2 17.25 7.25 17.1333 7.25 17C7.25 16.8667 7.2 16.75 7.1 16.65C7 16.55 6.88333 16.5 6.75 16.5C6.61667 16.5 6.5 16.55 6.4 16.65C6.3 16.75 6.25 16.8667 6.25 17C6.25 17.1333 6.3 17.25 6.4 17.35C6.5 17.45 6.61667 17.5 6.75 17.5ZM11.25 17.5C11.3833 17.5 11.5 17.45 11.6 17.35C11.7 17.25 11.75 17.1333 11.75 17C11.75 16.8667 11.7 16.75 11.6 16.65C11.5 16.55 11.3833 16.5 11.25 16.5C11.1167 16.5 11 16.55 10.9 16.65C10.8 16.75 10.75 16.8667 10.75 17C10.75 17.1333 10.8 17.25 10.9 17.35C11 17.45 11.1167 17.5 11.25 17.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19 14L23 18L21.6 19.425L20 17.85L20 22L18 22L18 17.85L16.4 19.425L15 18L19 14Z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApkFileUpload);
export default __webpack_public_path__ + "static/media/apk-file-upload.e7eabbfb51010ea294bb4d339fd0a814.svg";
export { ForwardRef as ReactComponent };